import type { RejectedMessagesFilterValues } from 'context/RejectedMessagesViewContext'
import { getRequest } from 'global/helpers/requests'
import type { PaginatedResults } from 'global/types/pagination'
import type { RejectedMessage } from './RejectedMessages.types'

const PREFIX = 'data-processing'

export const getFilteredRejectedMessages = async (
  page: number,
  filters: RejectedMessagesFilterValues,
): Promise<PaginatedResults<RejectedMessage>> => {
  const search = new URLSearchParams(
    Object.entries(filters).flatMap(([key, values]) => (values as string[]).map(value => [key, value]))
  )
  search.append('page', page.toString())
  return await getRequest<PaginatedResults<RejectedMessage>>(`rejected-messages?${search.toString()}`, {}, PREFIX)
}
